import React from 'react';
import { Button } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';

interface Props {
  date: string;
  onPrev: () => void;
  onNext: () => void;
  canGoNext: boolean;
}

const parseLocalDate = (iso: string): Date => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
};

const DayNavigator: React.FC<Props> = ({ date, onPrev, onNext, canGoNext }) => {
  const { language } = useTranslator();
  const formatter = new Intl.DateTimeFormat(language || undefined, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
  const label = formatter.format(parseLocalDate(date));
  const capitalized = label.charAt(0).toUpperCase() + label.slice(1);

  return (
    <div className="d-flex align-items-center gap-2" data-testid="day-navigator">
      <Button
        color="link"
        className="p-1"
        onClick={onPrev}
        aria-label="previous day"
        data-testid="day-navigator-prev"
      >
        ‹
      </Button>
      <span className="fw-medium" data-testid="day-navigator-label">
        {capitalized}
      </span>
      <Button
        color="link"
        className="p-1"
        onClick={onNext}
        disabled={!canGoNext}
        aria-label="next day"
        data-testid="day-navigator-next"
      >
        ›
      </Button>
    </div>
  );
};

export default DayNavigator;
